import React from 'react';
import { useAppRoute } from '../../../../../../hooks/app-route-hooks';
import { TimelineDetailPageContainer } from '../../../../../../components/TimelineDetailPageContainer';

export const OverviewSiteTimelineEventDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('OverviewSiteTimelineEventDetails');
    return (
        <TimelineDetailPageContainer
            testId="overview-site-timeline-event-details"
            appRoute={{
                type: 'OverviewSiteTimeline',
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            }}
        ></TimelineDetailPageContainer>
    );
};
